/**
 * Projects translations
 */
export const projects = {
  en: {
    projects: {
      title: "Projects",
      subtitle: "Manage all work engagements",
      newProject: "New Project",
      searchPlaceholder: "Search projects...",
      noProjects: "No projects found",
      noProjectsHint: "Create your first project.",
      tryDifferentFilters: "Try different filters.",
      createProject: "Create Project",
      deleteProject: "Delete project",
      deleteConfirmation:
        "This action cannot be undone. Tickets will be unlinked but not deleted.",
      // Detail page
      overview: "Overview",
      board: "Board",
      milestones: "Milestones",
      teamTab: "Team",
      details: "Details",
      planning: "Planning",
      phase: "Phase",
      hours: "Hours",
      budget: "Budget",
      startDate: "Start date",
      targetDate: "Target date",
      hoursProgress: "Hours",
      description: "Description",
      projectName: "Project name",
      serviceType: "Service type",
      selectCompany: "Select company",
      selectType: "Select type",
      company: "Company",
      status: "Status",
      tickets: "Tickets",
      hoursPurchased: "Hours purchased",
      budgetMin: "Budget min",
      budgetMax: "Budget max",
      // Board
      ticketBoard: "Ticket Board",
      ticketBoardDesc: "View all tickets for this project on the kanban board.",
      openBoard: "Open Board",
      // Milestones
      projectMilestones: "Project Milestones",
      milestonesDesc: "Milestones are managed from the planning section.",
      goToPlanning: "Go to Planning",
      // Team
      projectTeam: "Project Team",
      noTeam: "No members assigned to this project.",
      // Stats
      total: "Total",
      active: "Active",
      drafts: "Drafts",
      completed: "Completed",
    },
  },
  es: {
    projects: {
      title: "Proyectos",
      subtitle: "Gestiona todas las ejecuciones de trabajo",
      newProject: "Nuevo Proyecto",
      searchPlaceholder: "Buscar proyectos...",
      noProjects: "No se encontraron proyectos",
      noProjectsHint: "Crea tu primer proyecto.",
      tryDifferentFilters: "Intenta con otros filtros.",
      createProject: "Crear Proyecto",
      deleteProject: "Eliminar proyecto",
      deleteConfirmation:
        "Esta acción no se puede deshacer. Los tickets se desvinculan pero no se eliminan.",
      // Detail page
      overview: "General",
      board: "Tablero",
      milestones: "Milestones",
      teamTab: "Equipo",
      details: "Detalles",
      planning: "Planificación",
      phase: "Fase",
      hours: "Horas",
      budget: "Presupuesto",
      startDate: "Fecha inicio",
      targetDate: "Fecha objetivo",
      hoursProgress: "Horas",
      description: "Descripción",
      projectName: "Nombre del proyecto",
      serviceType: "Tipo de servicio",
      selectCompany: "Seleccionar empresa",
      selectType: "Seleccionar tipo",
      company: "Empresa",
      status: "Estado",
      tickets: "Tickets",
      hoursPurchased: "Horas compradas",
      budgetMin: "Presupuesto mín.",
      budgetMax: "Presupuesto máx.",
      // Board
      ticketBoard: "Tablero de tickets",
      ticketBoardDesc:
        "Ver todos los tickets de este proyecto en el tablero kanban.",
      openBoard: "Abrir Tablero",
      // Milestones
      projectMilestones: "Milestones del proyecto",
      milestonesDesc:
        "Los milestones se gestionan desde la sección de planificación.",
      goToPlanning: "Ir a Planificación",
      // Team
      projectTeam: "Equipo del Proyecto",
      noTeam: "No hay miembros asignados a este proyecto.",
      // Stats
      total: "Total",
      active: "Activos",
      drafts: "Borradores",
      completed: "Completados",
    },
  },
};
